import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Manufacture() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (


    <>
      <Helmet>
        <title>Find Reliable Customers for Your Business on TaskFlier - Join Today! </title>
      </Helmet>
        <div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
          <div class="container">
            <div class="row">
              <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
                <div class="pl-lg-5">
                  <div class="title-style-fourteen">
                    <h6><span class="upper-title custom-name">Manufacture</span></h6>
                    <h1>Quality, actionable data process.</h1>
                  </div>
                  <div class="tag-line">Creating an online survey has never been easier. With many advanced features of deski.</div>
                  <ul class="list-item">
                    <li>Easy-to-use survey maker interface</li>
                    <li>Drag and Drop to change the order of questions</li>
                    <li>Quota management</li>
                    <li>Step view layout for interactive survey filling experiences</li>
                    <li>Customizable URL</li>
                  </ul>
                  <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                <div class="illustration-holder d-inline-block md-mt-60">
                  <img src="/main/images/dashboard.png" alt="" class="w-100" />
                  <img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
                  <img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
                  <img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" />
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default Manufacture
